/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgFolderBookmarkBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11 5L11.5303 4.46967L11.3107 4.25H11V5ZM13 7L12.4697 7.53033L12.6893 7.75H13V7ZM14.6586 12.7239L15.1416 13.2977L15.1416 13.2977L14.6586 12.7239ZM16.2011 11.4254L15.7181 10.8517L15.7181 10.8517L16.2011 11.4254ZM16.4587 11.4254L16.9417 10.8517L16.9417 10.8517L16.4587 11.4254ZM18.0012 12.7239L17.5182 13.2977L17.5182 13.2977L18.0012 12.7239ZM3.75 17V7H2.25V17H3.75ZM5 5.75H11V4.25H5V5.75ZM10.4697 5.53033L12.4697 7.53033L13.5303 6.46967L11.5303 4.46967L10.4697 5.53033ZM13 7.75H19V6.25H13V7.75ZM20.25 9V17H21.75V9H20.25ZM19 18.25H5V19.75H19V18.25ZM19 7.75C19.6904 7.75 20.25 8.30964 20.25 9H21.75C21.75 7.48122 20.5188 6.25 19 6.25V7.75ZM3.75 7C3.75 6.30964 4.30964 5.75 5 5.75V4.25C3.48122 4.25 2.25 5.48122 2.25 7H3.75ZM20.25 17C20.25 17.6904 19.6904 18.25 19 18.25V19.75C20.5188 19.75 21.75 18.5188 21.75 17H20.25ZM2.25 17C2.25 18.5188 3.48122 19.75 5 19.75V18.25C4.30964 18.25 3.75 17.6904 3.75 17H2.25ZM13.5798 7.20073V12.5709H15.0798V7.20073H13.5798ZM15.1416 13.2977L16.6841 11.9992L15.7181 10.8517L14.1756 12.1502L15.1416 13.2977ZM15.9757 11.9992L17.5182 13.2977L18.4842 12.1502L16.9417 10.8517L15.9757 11.9992ZM19.08 12.5709V7.20073H17.58V12.5709H19.08ZM18.13 6.25073H14.5298V7.75073H18.13V6.25073ZM19.08 7.20073C19.08 6.67606 18.6546 6.25073 18.13 6.25073V7.75073C17.8262 7.75073 17.58 7.50449 17.58 7.20073H19.08ZM17.5182 13.2977C18.136 13.8178 19.08 13.3786 19.08 12.5709H17.58C17.58 12.1033 18.1265 11.849 18.4842 12.1502L17.5182 13.2977ZM16.6841 11.9992C16.4794 12.1715 16.1804 12.1715 15.9757 11.9992L16.9417 10.8517C16.5881 10.554 16.0717 10.554 15.7181 10.8517L16.6841 11.9992ZM13.5798 12.5709C13.5798 13.3786 14.5238 13.8178 15.1416 13.2977L14.1756 12.1502C14.5333 11.849 15.0798 12.1033 15.0798 12.5709H13.5798ZM15.0798 7.20073C15.0798 7.50449 14.8336 7.75073 14.5298 7.75073V6.25073C14.0051 6.25073 13.5798 6.67606 13.5798 7.20073H15.0798Z"
      fill="currentColor"
    />
  </svg>
);
const SvgFolderBookmark = wrapIcon(SvgFolderBookmarkBase);
export default SvgFolderBookmark;
